(function () {

    'use strict';

    angular.module('iplusjs.tooltip.content', [
        'lodash'
    ])
    .component('iplusjsTooltipContent', {
        restrict: 'AE',
        transclude: true,
        bindings: {
            name: '@itcName',
            close: '@itcClose'
        },
        templateUrl: 'common/tooltip/tooltipContent.html',
        controller: TooltipContentController,
        controllerAs: 'tooltipContentVm'
    });

    TooltipContentController.$inject = [
        'lodash'
    ];
    function TooltipContentController(_) {
        var vm = this;

        vm.$onInit = onInit;

        function onInit() {
            if (_.isNil(vm.name)) {
                throw 'itcName attribute is missing!';
            }

            vm.hasClose = vm.close === 'false' ? false : true;
            vm.id = 'dt-' + vm.name;
        }
    }
})();
